import React from 'react';
import { Divider, Switch } from 'src/components/atoms';
import {
  CategoryToggleStack,
  IntakeChannelRow,
  IntakeChannelRowLabel,
  IntakeChannelRows,
  IntakeChannelsCard,
  IntakeChannelsSectionHeader,
  IntakeSectionTitle,
  SectionDescription,
  SwitchHeader,
  SwitchHelpText,
  SwitchLabel,
  SwitchSection,
} from './Configuration.styles';

export interface SpeakUpCategoryExpandedFieldsProps {
  isExistingCategorySelected: boolean;
  isDeterminedCategory: boolean;
  setIsDeterminedCategory: React.Dispatch<React.SetStateAction<boolean>>;
  isReportedCategory: boolean;
  setIsReportedCategory: React.Dispatch<React.SetStateAction<boolean>>;
  intakeChannelReportingPortal: boolean;
  setIntakeChannelReportingPortal: React.Dispatch<
    React.SetStateAction<boolean>
  >;
  intakeChannelGoTogether: boolean;
  setIntakeChannelGoTogether: React.Dispatch<React.SetStateAction<boolean>>;
}

export const SpeakUpCategoryExpandedFields = ({
  isExistingCategorySelected,
  isDeterminedCategory,
  setIsDeterminedCategory,
  isReportedCategory,
  setIsReportedCategory,
  intakeChannelReportingPortal,
  setIntakeChannelReportingPortal,
  intakeChannelGoTogether,
  setIntakeChannelGoTogether,
}: SpeakUpCategoryExpandedFieldsProps) => (
  <>
    <Divider variant="horizontal" />

    <CategoryToggleStack data-testid="category-toggle-stack">
      <SwitchSection data-testid="determined-category-section">
        <SwitchHeader>
          <Switch
            checked={isDeterminedCategory}
            onClick={() => {
              if (!isExistingCategorySelected) {
                setIsDeterminedCategory(!isDeterminedCategory);
              }
            }}
            disabled={isExistingCategorySelected}
            data-testid="determined-category-toggle"
          />
          <SwitchLabel>Determined category</SwitchLabel>
        </SwitchHeader>
        <SwitchHelpText>
          This allows the category to be selected in Resolution Hub
        </SwitchHelpText>
      </SwitchSection>
      <SwitchSection data-testid="reported-category-section">
        <SwitchHeader>
          <Switch
            checked={isReportedCategory}
            onClick={() => {
              if (!isExistingCategorySelected) {
                setIsReportedCategory(!isReportedCategory);
              }
            }}
            disabled={isExistingCategorySelected}
            data-testid="reported-category-toggle"
          />
          <SwitchLabel>Reported category</SwitchLabel>
        </SwitchHeader>
        <SwitchHelpText>
          This allows the category to be selected by reporters across intake
          channels
        </SwitchHelpText>
      </SwitchSection>
    </CategoryToggleStack>

    <IntakeChannelsCard data-testid="intake-channel-section">
      <IntakeChannelsSectionHeader>
        <IntakeSectionTitle>Intake channels</IntakeSectionTitle>
        <SectionDescription>
          The category will appear in the selected intake channels.
        </SectionDescription>
      </IntakeChannelsSectionHeader>
      <IntakeChannelRows>
        <IntakeChannelRow>
          <Switch
            checked={intakeChannelReportingPortal}
            onClick={() => {
              if (!isExistingCategorySelected) {
                setIntakeChannelReportingPortal(!intakeChannelReportingPortal);
              }
            }}
            disabled={isExistingCategorySelected}
            data-testid="intake-channel-reporting-portal-toggle"
          />
          <IntakeChannelRowLabel $disabled={isExistingCategorySelected}>
            Vault
          </IntakeChannelRowLabel>
        </IntakeChannelRow>
        <IntakeChannelRow $inset>
          <Switch
            checked={intakeChannelGoTogether}
            onClick={() => {
              if (!isExistingCategorySelected) {
                setIntakeChannelGoTogether(!intakeChannelGoTogether);
              }
            }}
            disabled={isExistingCategorySelected}
            data-testid="intake-channel-go-together-toggle"
          />
          <IntakeChannelRowLabel $disabled={isExistingCategorySelected}>
            GoTogether
          </IntakeChannelRowLabel>
        </IntakeChannelRow>
      </IntakeChannelRows>
    </IntakeChannelsCard>
  </>
);
